import type { PropsWithChildren } from "react";
import { tv } from "tailwind-variants";

import { ScrollArea } from "@/shared/ui";

const styles = tv({
  slots: {
    base: "bg-white",
    content: "flex h-full flex-col gap-7 p-6 md:px-16 md:py-12",
  },
});

const { base, content } = styles();

export const AdminScreenContentLayout = ({ children }: PropsWithChildren) => {
  return (
    <ScrollArea className={base()}>
      <div className={content()}>{children}</div>
    </ScrollArea>
  );
};
